import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import { LinkGrid } from '../../../components/linkgrid/LinkGrid'
import { PopularGuideArticlesFragment } from '@gql'

export type PopularGuideArticlesProps = {
  articles: PopularGuideArticlesFragment[]
}

const StyledGridItem = styled(LinkGrid)`
  font-weight: 500;
  color: ${props => props.theme.palette.text.primary};
  padding: ${props => props.theme.typography.pxToRem(0)};
`

export const PopularGuideArticles: React.FC<PropsWithChildren<PopularGuideArticlesProps>> = ({ articles }) => {
  if (articles === undefined || articles === null || articles.length === 0) {
    return null
  }

  return (
    <React.Fragment>
      <LinkGrid variant="dark">
        {
          articles.length> 0 && articles.map((article, i)  => {
            return (
              <StyledGridItem key={i} linkWrapper>
                <LinkGrid link href={article.popularGuidePageLink?.url || '#'} target={article.popularGuidePageLink?.target === '_blank' ? '_blank' : '_self'}>{article.popularGuidePageTitle}</LinkGrid>
              </StyledGridItem>
            )
          })
        }
      </LinkGrid>
    </React.Fragment>
  )
}
